export enum EstrategiaPreco {
    PrecoDefinido = 0,
    MaiorPreco = 1
}